export default __webpack_public_path__ + "static/media/882.da7d36cf.jpg";